export default __webpack_public_path__ + "static/media/ksivalue_main_mobile_small.acb7142f.jpg";